import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    data: {
        childBacs: [],
        parentBac: '',
        loading: false,
        error: ''
    }
};

export const childBacSlice = createSlice({
    name: 'childBac',
    initialState,
    reducers: {
        fetchChildBacStart: (state, action) => {
            state.data.loading = true;
            state.data.error = '';
            state.data.parentBac = action.payload?.parentBac || state.data.parentBac;
            state.data.childBacs = [];
        },
        setChildBacs: (state, action) => {
            state.data.loading = false;
            state.data.error = '';
            state.data.parentBac = action.payload?.parentBac || '';
            state.data.childBacs = Array.isArray(action.payload?.childBacs) ? action.payload.childBacs : [];
        },
        fetchChildBacFailure: (state, action) => {
            state.data.loading = false;
            state.data.error = action.payload?.error || 'Unable to fetch child BAC list';
            state.data.parentBac = action.payload?.parentBac || state.data.parentBac;
            state.data.childBacs = [];
        },
        resetChildBacs: (state) => {
            state.data = {
                childBacs: [],
                parentBac: '',
                loading: false,
                error: ''
            };
        }
    }
});

export const { fetchChildBacStart, setChildBacs, fetchChildBacFailure, resetChildBacs } = childBacSlice.actions;

export default childBacSlice.reducer;
